/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Alert,
} from "reactstrap"; // Assumindo que você tem o apiClient configurado
import api from "../../../services/axiosConfig";

function ManutencaoModal({ isOpen, toggle }) {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    isActive: false,
  });
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const fetchStatus = async () => {
        setIsLoading(true);
        setMessage({ text: "", type: "" });
        try {
          const response = await api.get("/manutencao");
          setFormData(response.data);
        } catch (error) {
          console.error(error);
          setMessage({
            text: "Erro ao carregar dados da manutenção.",
            type: "danger",
          });
        } finally {
          setIsLoading(false);
        }
      };

      fetchStatus();
    }
  }, [isOpen]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const finalValue = type === "checkbox" ? checked : value;
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const response = await api.post("/manutencao", {
        title: formData.title,
        description: formData.description,
        isActive: formData.isActive,
      });
      setMessage({ text: response.data.message, type: "success" });

      setTimeout(() => {
        toggle();
      }, 1500);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Erro ao salvar.";
      setMessage({ text: errorMessage, type: "danger" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Controle de Manutenção</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {isLoading && !formData.title ? (
            <div className="text-center">
              <Spinner color="primary">Loading...</Spinner>
            </div>
          ) : (
            <>
              {message.text && (
                <Alert color={message.type}>{message.text}</Alert>
              )}
              <FormGroup>
                <Label for="title">Título</Label>
                <Input
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="description">Descrição</Label>
                <Input
                  id="description"
                  name="description"
                  type="textarea"
                  rows={4}
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup switch>
                <Input
                  id="isActive"
                  name="isActive"
                  type="switch"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
                <Label check>Ativar Modo Manutenção</Label>
              </FormGroup>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={isLoading}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Salvar"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default ManutencaoModal;
